import { Dispatch, SetStateAction } from "react";
import { Modal, Button, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  type?: string;
}

export default function AddTaxModal({
  open,
  onClose,
  setOpen,
  type = "add",
}: ModalProps) {
  return (
    <Modal
      className="modal addCategory_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>{type === "edit" ? "Edit Tax" : "Add Tax"}</h2>

            {/* Accessible close button */}
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
            >
              <CloseIcon />
            </button>
          </div>

          <form className="form" action="">
            <div className="gap_p">
              <div className="control_group w_100">
                <label htmlFor="tax-name">Tax Name</label>
                <TextField
                  id="tax-name"
                  fullWidth
                  hiddenLabel
                  placeholder="Enter Tax Name"
                />
              </div>

              <div className="control_group w_100">
                <label htmlFor="tax-value">Tax Value (%)</label>
                <TextField
                  id="tax-value"
                  fullWidth
                  hiddenLabel
                  placeholder="Enter Tax Value (%)"
                />
              </div>
            </div>

            <div className="footer_btn_flex">
              <Button
                className="btn btn_grey"
                onClick={() => setOpen(false)}
              >
                Cancel
              </Button>
              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
